// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_undismissMatch(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MatchUndismissed"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"undismissMatch_MatchUndismissed_match_source":{"f":""},"undismissMatch":{"u":"response_undismissMatch"}}};

var wrapResponseConverterMap = {
  response_undismissMatch: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"undismissMatch_MatchUndismissed_match_source":{"f":""},"undismissMatch":{"u":"response_undismissMatch"}}};

var responseConverterMap = {
  response_undismissMatch: unwrap_response_undismissMatch
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "matchId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ClientPageMobileTabs_matchable"
},
v6 = [
  {
    "kind": "Literal",
    "name": "dismissalState",
    "value": "UNDISMISSED"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleMatchDismissButton_UndismissMatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "undismissMatch",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "match",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ForSalePropertyV5",
                        "kind": "LinkedField",
                        "name": "source",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MatchForForSalePropertyV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalPropertyV5",
                        "kind": "LinkedField",
                        "name": "source",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "LandlordPageMatchesSection_TotalMatchCount_rentalPropertyV5"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MatchForRentalPropertyV5",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MatchUndismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ToggleMatchDismissButton_UndismissMatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "undismissMatch",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "match",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "nodeId",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ForSalePropertyV5",
                        "kind": "LinkedField",
                        "name": "source",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "numberOfMatches",
                                "args": (v6/*: any*/),
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "matches",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                              }
                            ],
                            "type": "Matchable",
                            "abstractKey": "__isMatchable"
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MatchForForSalePropertyV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalPropertyV5",
                        "kind": "LinkedField",
                        "name": "source",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "numberOfMatches",
                            "args": (v6/*: any*/),
                            "concreteType": "RentalPropertyMatchConnection",
                            "kind": "LinkedField",
                            "name": "matches",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                          },
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "numberOfMatches",
                                "args": (v6/*: any*/),
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "matches",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/)
                                ],
                                "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
                              }
                            ],
                            "type": "Matchable",
                            "abstractKey": "__isMatchable"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MatchForRentalPropertyV5",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MatchUndismissed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3922c61083f04fbfad8bcd2a3362f684",
    "id": null,
    "metadata": {},
    "name": "ToggleMatchDismissButton_UndismissMatchMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleMatchDismissButton_UndismissMatchMutation(\n  $matchId: ID!\n) {\n  undismissMatch(input: {id: $matchId}) {\n    __typename\n    ... on MatchUndismissed {\n      match {\n        __typename\n        nodeId\n        ... on MatchForForSalePropertyV5 {\n          source {\n            ...ClientPageMobileTabs_matchable\n            nodeId\n          }\n        }\n        ... on MatchForRentalPropertyV5 {\n          source {\n            ...ClientPageMobileTabs_matchable\n            ...LandlordPageMatchesSection_TotalMatchCount_rentalPropertyV5\n            nodeId\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ClientPageMobileTabs_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  numberOfMatches: matches(dismissalState: UNDISMISSED) {\n    __typename\n    totalCount\n  }\n}\n\nfragment LandlordPageMatchesSection_TotalMatchCount_rentalPropertyV5 on RentalPropertyV5 {\n  numberOfMatches: matches(dismissalState: UNDISMISSED) {\n    totalCount\n  }\n}\n"
  }
};
})());

var wrap_response_undismissMatch = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_undismissMatch = unwrap_response_undismissMatch;
exports.wrap_response_undismissMatch = wrap_response_undismissMatch;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
